module.exports = __webpack_public_path__ + "img/2307.45fdce91.jpg";